import {GraphicsApi} from "../../../../api/GraphicsApi";

export default {
    data() {
        return {
            dialog: false,
            premiumRequiredDialog: false,
            graphicDetails: {},
            searchTermId: null,
            actionTypeMessage: {
                resultOpen: 'Search result opened',
                jumpToSection: 'Jump to section clicked',
                subscribeToPremiumClick: 'Subscribe to premium button clicked',
                learnMoreBtnClick:'Learn more button clicked'
            },
            accessLevelMsg: {
                basic: 'Basic',
                premium: 'Premium Required',
                premiumActive: 'Premium Active'
            }
        }
    },
    computed: {
        redirectLink() {
            return Routing.generate('content_id_redirect', {
                'contentId': this.graphicDetails.content_id
            });
        }
    },
    methods : {
        getAccessLevel(sku, contentAccessLevelId) {
            if (this.isPremiumSubscribed(sku)) {
                return 'premiumActive';
            }

            if (this.isBasicAccessBook(contentAccessLevelId)) {
                return 'basic';
            }

            return 'premium';
        },
        loadPlaceholderImage(e) {
            e.target.src = this.asset(require('../../../../images/graphics_image_missing.png'));
        },
        isNotEmptyObject(obj) {
            return obj && Object.keys(obj).length > 0;
        },
        removeAllImagesFromDom(content) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(content, 'text/html');
            if (doc.querySelector("parsererror")) {
                return content;
            }
            const images = doc.querySelectorAll('img');
            images.forEach(img => img.remove());
            return doc.documentElement.outerHTML;
        },
        async logSearchClick(actionTaken) {
            const accessLevel = this.getAccessLevel(
                this.graphicDetails.document_sku,
                this.graphicDetails.content_access_level_id
            );
            const logRequest = {
                searchTermId: this.searchTermId,
                documentId: this.graphicDetails.document_id,
                contentId: this.graphicDetails.content_id,
                sectionTitle: this.graphicDetails.section_title,
                accessLevel: this.accessLevelMsg[accessLevel],
                action: actionTaken
            }
            await GraphicsApi.logGraphicSearchClick(logRequest);
        },
    }
}
